/* Kivora v6.12.0 — cart drawer + fetch add-to-cart.
   Progressive enhancement over the native forms: if anything here fails, the
   form still posts natively to /cart and nothing is lost.

   Reglas que respeta:
   - Los formularios con return_to (las ad-landings van directas a /checkout)
     no se interceptan.
   - En /cart no hay cajon (la seccion no se pinta alli) y por tanto tampoco
     interceptacion: todo va nativo como hasta ahora.
   - kivora-system.js ya marca el boton como ocupado en el mismo evento submit
     (corre antes porque su listener se registro antes); aqui solo se libera
     cuando el fetch termina.
   - El pixel de Meta y cualquier web pixel de Shopify capturan los altas por
     fetch igual que las nativas: no hay que disparar eventos a mano. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawerEl() { return document.getElementById('kv-cart'); }
  /* v6.14: el nodo puede existir en el HTML sin que kivora-system.js haya
     llegado a definir <kv-drawer>. Sin el metodo .open, interceptar el submit
     dejaria el alta completamente muda; se comprueba la pieza que importa. */
  function drawerReady() {
    var el = drawerEl();
    return (el && typeof el.open === 'function') ? el : null;
  }

  function unbusy(form) {
    form.kvAdding = false;
    form.removeAttribute('data-kv-busy');
    /* v6.14: kivora-system.js arma un timeout de 8s que apagaba el spinner de
       un SEGUNDO envio posterior. Aqui se cancela al resolverse el fetch. */
    if (form._kvT) { window.clearTimeout(form._kvT); form._kvT = null; }
    /* v6.14: el boton pulsado puede vivir FUERA del form (form="id", como
       los CTA de kv-adpack); kivora-system.js lo deja en form._kvBtn. */
    var btn = form._kvBtn || form.querySelector('[data-add]');
    if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-disabled'); }
  }

  function announce(text) {
    var live = document.querySelector('[data-cd-live]');
    if (!live) { return; }
    /* Un frame de respiro: si el texto repite el anterior, el lector no lo
       anunciaria; vaciar y rellenar fuerza el aviso. */
    live.textContent = '';
    window.setTimeout(function () { live.textContent = text; }, 60);
  }

  function setCount(n) {
    var openers = document.querySelectorAll('[data-drawer-open="kv-cart"]');
    for (var i = 0; i < openers.length; i++) {
      var el = openers[i];
      /* La badge solo tiene sentido en el boton icono; el CTA textual del
         menu movil lleva su propia cifra (data-cart-count-text). */
      if (el.classList.contains('kv-iconbtn')) {
        var badge = el.querySelector('.kv-count');
        if (n > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'kv-count';
            el.appendChild(badge);
          }
          badge.textContent = n;
        } else if (badge) {
          badge.parentNode.removeChild(badge);
        }
      }
      if (el.hasAttribute('aria-label')) {
        el.setAttribute('aria-label', 'Cart, ' + n + ' item' + (n === 1 ? '' : 's'));
      }
    }
    var texts = document.querySelectorAll('[data-cart-count-text]');
    for (var t = 0; t < texts.length; t++) { texts[t].textContent = n; }
  }

  /* v6.14: pinta el HTML nuevo del panel conservando el scroll y el foco.
     panel.innerHTML reconstruye el arbol entero: sin esto, cambiar la
     cantidad de la linea 12 devolvia el cajon arriba del todo y soltaba el
     foco en <body> (y con el foco fuera, el Tab se escapaba del modal). */
  function paintPanel(el, html) {
    var panel = el.querySelector('[data-panel]');
    if (!panel) { return null; }
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    var next = tpl.content.querySelector('[data-panel]');
    if (!next) { return null; }

    var scroller = panel.querySelector('.kv-cd__body');
    var keepTop = scroller ? scroller.scrollTop : 0;
    var act = document.activeElement;
    var keepStep = null;
    if (act && panel.contains(act) && act.matches && act.matches('[data-step], [data-cd-qty]')) {
      var line = act.closest('.kv-cd__line');
      keepStep = {
        sel: act.hasAttribute('data-step') ? '[data-step="' + act.getAttribute('data-step') + '"]' : '[data-cd-qty]',
        line: line ? Array.prototype.indexOf.call(panel.querySelectorAll('.kv-cd__line'), line) : -1
      };
    }

    panel.innerHTML = next.innerHTML;

    var scroller2 = panel.querySelector('.kv-cd__body');
    if (scroller2) { scroller2.scrollTop = keepTop; }
    if (keepStep && keepStep.line > -1 && el.hasAttribute('open')) {
      var lines = panel.querySelectorAll('.kv-cd__line');
      var back = lines[keepStep.line] ? lines[keepStep.line].querySelector(keepStep.sel) : null;
      if (!back) { back = panel.querySelector('[data-close]'); }
      if (back && back.focus) { try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); } }
    }
    return panel;
  }

  function afterPaint(el, panel, openAfter, message) {
    var countNode = panel ? panel.querySelector('[data-cd-count]') : null;
    var n = countNode ? parseInt(countNode.textContent, 10) || 0 : 0;
    setCount(n);
    if (message) { announce(message); }
    if (openAfter) {
      if (typeof el.open === 'function') { el.open(); }
      else { window.location.href = root + 'cart'; }
    }
  }

  /* Re-renders the drawer from the server so the markup only ever lives in
     sections/kv-cart-drawer.liquid. Falls back to a plain navigation if the
     Section Rendering API is unreachable. */
  /* v6.13: contador de secuencia; dos refresh solapados podian pintar la
     respuesta vieja encima de la nueva. Solo la ultima peticion pinta. */
  var seq = 0;
  function refresh(openAfter, message) {
    var el = drawerEl();
    if (!el) { return Promise.resolve(); }
    var my = ++seq;
    var panel = el.querySelector('[data-panel]');
    if (panel) { panel.classList.add('is-loading'); }
    return fetch(root + '?sections=kv-cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) { throw new Error('sections'); } return r.json(); })
      .then(function (json) {
        if (my !== seq) { return; }
        var html = json['kv-cart-drawer'];
        if (!html) { throw new Error('sections'); }
        var painted = paintPanel(el, html);
        afterPaint(el, painted || panel, openAfter, message);
      })
      .catch(function (err) {
        /* v6.13: se marca el fallo como de re-render para que quien llamo
           pueda distinguirlo de un fallo del alta y no lo pinte como error
           del producto. */
        if (err) { try { err.kvStep = 'refresh'; } catch (e2) { /* sellado */ } }
        throw err;
      })
      .finally(function () { if (panel && my === seq) { panel.classList.remove('is-loading'); } });
  }

  /* ------------------------------------------------------ add to cart */
  /* v6.14: el boton que disparo el submit, para poder pintar el error donde
     el cliente esta mirando (la barra pegajosa esta a pantallas del form). */
  var lastAddBtn = null;
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[type="submit"][name="add"]');
    if (b) { lastAddBtn = b; }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) { return; }
    /* v6.14: sin custom element operativo se deja pasar el submit nativo:
       el fallback prometido en la cabecera vuelve a ser verdad. */
    if (!drawerReady()) { return; }
    if (form.querySelector('input[name="return_to"]')) { return; }
    if (e.defaultPrevented) { return; }
    /* v6.13: guard propio contra el doble envio. kivora-system.js pone
       data-kv-busy en este mismo evento (corre antes), asi que el atributo
       recien puesto no distingue este submit de uno anterior: la marca
       kvAdding cubre el fetch en vuelo aunque ese script no haya cargado. */
    if (form.kvAdding) { e.preventDefault(); return; }
    e.preventDefault();
    form.kvAdding = true;
    if (form.getAttribute('data-kv-busy') !== '1') { form.setAttribute('data-kv-busy', '1'); }

    var err = document.querySelector('[data-cd-error]');
    if (err) { err.remove(); }

    var submitter = (e.submitter && e.submitter.name === 'add') ? e.submitter : lastAddBtn;

    /* v6.14: el drawer viaja en la MISMA respuesta del alta (Cart AJAX API,
       parametro sections). Antes eran dos viajes en serie: add.js y luego
       ?sections=..., facilmente 800-1400ms de boton girando en 4G. */
    var body = new FormData(form);
    body.append('sections', 'kv-cart-drawer');
    body.append('sections_url', window.location.pathname);
    fetch(root + 'cart/add.js', {
      method: 'POST',
      body: body,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (r.ok) { return r.json(); }
        return r.json().then(function (j) { throw j; });
      })
      .then(function (json) {
        var el = drawerEl();
        var html = json && json.sections && json.sections['kv-cart-drawer'];
        if (el && html) {
          seq++; /* invalida cualquier refresh en vuelo */
          var painted = paintPanel(el, html);
          if (painted) {
            /* Un refresh invalidado ya no limpia su is-loading (my !== seq);
               sin esto el cajon quedaba atenuado y muerto para siempre. */
            painted.classList.remove('is-loading');
            afterPaint(el, painted, true, 'Added to cart');
            return;
          }
        }
        return refresh(true, 'Added to cart');
      })
      .catch(function (problem) {
        /* v6.13: si el alta funciono pero el re-render fallo, no es un error
           del producto: se navega al carrito (el fallback que promete la
           cabecera) y nunca se ensena un texto interno como "sections". */
        if (problem && problem.kvStep === 'refresh') {
          window.location.href = root + 'cart';
          return;
        }
        var msg = (problem && (problem.description || problem.message)) || 'Could not add this to the cart. Please try again.';
        var p = document.createElement('p');
        p.className = 'kv-cd-error';
        p.setAttribute('data-cd-error', '');
        p.setAttribute('role', 'alert');
        p.textContent = msg;
        /* Junto al boton pulsado, no al principio del formulario. */
        var host = (submitter && submitter.closest && submitter.closest('kv-stickybar, .kv-pdp__buy, .kv-pl-hero__buy, .kv-apk__herocta, .kv-apk-buy')) || form;
        host.appendChild(p);
      })
      .finally(function () { unbusy(form); });
  });

  /* -------------------------------------- quantity + remove, delegated */
  /* v6.13: un timer POR LINEA; con uno global, cambiar la cantidad de la
     linea A y luego la B en <250ms perdia el cambio de A. */
  var qtyTimers = {};
  /* v6.14: cambios aun no enviados (debounce en vuelo), para poder vaciarlos
     antes de irse al checkout. */
  var qtyPending = {};
  /* v6.13.1: los cambios van EN SERIE. Dos /cart/change.js simultaneos
     chocan en Shopify (conflicto de carrito) y el fallback expulsaba al
     cliente a /cart. La cola garantiza un cambio tras otro. */
  var lineChain = Promise.resolve();
  function doChange(key, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        if (r.ok) { return r.json(); }
        /* v6.14: un 422 es una regla de negocio (stock, limite), no una
           averia. Se convierte en mensaje en vez de expulsar a /cart. */
        if (r.status === 422) {
          return r.json().then(function (j) {
            var soft = new Error(j.description || j.message || 'We could not update that quantity.');
            soft.kvSoft = true;
            throw soft;
          });
        }
        throw new Error('change');
      });
  }
  /* v6.14: si el ultimo cambio de cantidad fue rechazado (422), el checkout
     no debe salir con una cifra que el cliente cree distinta. */
  var softBlocked = false;
  function lineError(text) {
    var foot = document.querySelector('.kv-cd__foot') || document.querySelector('.kv-cd__body');
    if (!foot) { return; }
    var old = document.querySelector('[data-cd-error]');
    if (old) { old.remove(); }
    var p = document.createElement('p');
    p.className = 'kv-cd-error';
    p.setAttribute('data-cd-error', '');
    p.setAttribute('role', 'alert');
    p.textContent = text;
    foot.insertBefore(p, foot.firstChild);
  }
  function changeLine(key, quantity) {
    lineChain = lineChain
      .then(function () { return doChange(key, quantity); })
      .then(function () { softBlocked = false; return refresh(false, quantity === 0 ? 'Item removed' : 'Cart updated'); })
      .catch(function (err) {
        if (err && err.kvSoft) {
          /* El carrito no cambio: se repinta el estado real y se explica. */
          softBlocked = true;
          return refresh(false, '')
            .then(function () { lineError(err.message); })
            .catch(function () { window.location.href = root + 'cart'; });
        }
        window.location.href = root + 'cart';
      });
    return lineChain;
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-cd-qty]')) { return; }
    var key = input.getAttribute('data-key');
    if (!key) { return; }
    var q = parseInt(input.value, 10);
    /* v6.14: el campo vaciado a mano dejaba la linea en un limbo sin
       feedback; se repinta el estado real del carrito. */
    if (isNaN(q) || q < 0) { refresh(false, ''); return; }
    qtyPending[key] = q;
    window.clearTimeout(qtyTimers[key]);
    qtyTimers[key] = window.setTimeout(function () {
      delete qtyPending[key];
      changeLine(key, q);
    }, 250);
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-cd-remove]');
    if (!link) { return; }
    e.preventDefault();
    changeLine(link.getAttribute('data-key'), 0);
  });

  /* --------------------------------------------- checkout, sin carreras */
  /* v6.14: antes el checkout era un <a href>: pulsar "+" y tocar Checkout en
     el mismo segundo se llevaba la navegacion ANTES del /cart/change.js y el
     cliente pagaba la cantidad vieja. Ahora es un form; se vacian los
     cambios pendientes y solo entonces se envia. */
  function flushQty() {
    var keys = Object.keys(qtyPending);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i], v = qtyPending[k];
      window.clearTimeout(qtyTimers[k]);
      delete qtyPending[k];
      changeLine(k, v);
    }
    return lineChain;
  }
  /* El guard de doble envio vive a nivel de modulo: el repintado del panel
     reemplaza el <form>, asi que una marca en el nodo se perderia. */
  var goingLock = false, goingTimer = null;
  function releaseGo() {
    goingLock = false;
    window.clearTimeout(goingTimer); goingTimer = null;
    var b = document.querySelector('[data-cd-checkout]');
    if (b) { b.classList.remove('is-busy'); b.removeAttribute('aria-disabled'); }
  }
  /* 21-08: al volver atras desde el checkout (bfcache en Safari) el cerrojo
     seguia echado y el segundo clic no hacia nada. */
  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted || goingLock) { releaseGo(); }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-cd-go]')) { return; }
    if (goingLock) { e.preventDefault(); return; }
    e.preventDefault();
    goingLock = true;
    var btn = form.querySelector('[data-cd-checkout]');
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-disabled', 'true'); }
    var go = function () {
      var live = document.querySelector('form[data-cd-go]');
      if (live && live.isConnected) { live.submit(); }
      else if (form.isConnected) { form.submit(); }
      else { window.location.href = root + 'cart'; }
    };
    /* Tope de 4 s: si el vaciado de cantidades no responde, se envia igual;
       el checkout recalcula el carrito de todos modos. */
    goingTimer = window.setTimeout(function () { if (goingLock) { go(); } }, 4000);
    flushQty()
      .catch(function () { /* changeLine ya navega a /cart si algo fallo */ })
      .then(function () {
        if (softBlocked) { releaseGo(); return; }
        window.clearTimeout(goingTimer);
        go();
      });
  });

  /* ------------------------------------------- /cart: cantidades en vivo */
  /* Sin cajon aqui: el formulario nativo es la unica fuente de verdad, asi
     que se pulsa el mismo boton "update" que ya existe. Recarga la pagina,
     pero el total nunca contradice a la caja de cantidad. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('#kv-cart-form input[name^="updates["]')) { return; }
    var form = input.form;
    if (!form || form.kvUpdating) { return; }
    var upd = form.querySelector('button[name="update"]');
    if (!upd) { return; }
    window.clearTimeout(form._kvUpdT);
    form._kvUpdT = window.setTimeout(function () {
      form.kvUpdating = true;
      upd.click();
    }, 500);
  });

  /* v6.14: puerta publica minima para que otras secciones (kv-bundles)
     reutilicen el cajon en vez de navegar a /cart. */
  window.KivoraCart = { refresh: refresh, setCount: setCount };
})();
